import type { Ability, Section } from "@qendo/permissions";
import { Can, type CanProps } from "~/components/permission/Can";

type CanAnyProps<S extends Section, A extends Ability<S>> = Omit<CanProps<S, A>, "any">;

export const CanAny = <S extends Section = Section, A extends Ability<S> = Ability<S>>({
    children,
    ...canProps
}: CanAnyProps<S, A>) => {
    return (
        <Can {...canProps} any>
            {children}
        </Can>
    );
};
